import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Typography, Box, Grid } from '@mui/material'
import { HelpRounded } from '@mui/icons-material';
import Parser from 'html-react-parser';

import { useStyles } from './CreditQuoteStyles'
import { CustomAlertHelpDialog, CustomLoadingOverlay, GenericContainer, Buttons, GenericDialog, GenericContainerCenter } from '../../components'
import { fileActions } from '../../store/actions'
import { coreFunctions } from '../../utils'//funciones del nucleo
import { useTranslation } from "react-i18next";

const formatterDolar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
})

export default function CreditOfferComponent(props) {
    const location = useLocation()
    const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader 
    const [fileId, setFileId] = useState(0)
    const [agrupadorDocumental, setAgrupadorDocumental] = useState('Datos del crédito')
    const [activeUpdateMetadata, setActiveUpdateMetadata] = useState(false)

    // Titulo
    const [title, setTitle] = useState('')
    const [folio, setFolio] = useState('')
    const [monto, setMonto] = useState('')
    const [plazo, setPlazo] = useState('')
    const [titleDescuento, setTitleDescuento] = useState('')
    const [titleButton, setTitleButton] = useState('')
    const [descuento, setDescuento] = useState('')
    const [cat, setCat] = useState('')
    const [tasa, setTasa] = useState('')
    const [activeFileInfo, setActiveFileInfo] = useState(false)

    const [open, setOpen] = useState(false);
    const localStyles = useStyles()
    const navigate = useNavigate()

    //Redux hooks
    const file = useSelector(state => state.FileInfo)
    const fileUpdateMetadata = useSelector(state => state.File)

    const dispatch = useDispatch()
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        setActiveFileInfo(true)
        setFileId(location.state.folioId)
        GetNameTitle(location.state.stage.Stage?.Properties)
        console.log("---------location.state----------: ", location.state)
    }, []);

    useEffect(() => {
        setLoadView(file.loading)
        if (file.items != undefined && activeFileInfo) {
            setActiveFileInfo(false)
            GetNameTitle(location.state.stage.Stage?.Properties)
            console.log("file.items", file.items)
            setFolio(file.items.Folio)
            setTitleDescuento('Descuento:')
            setTitleButton(location.state.IsCalculator == "true" ? 'Editar oferta' : t("general_cancel"))
            setMonto(location.state.IsCalculator == "true" ? formatterDolar.format(location.state.items.Monto) : location.state.items.Monto)
            setPlazo(location.state.IsCalculator == "true" ? `${location.state.items.Plazo} ${location.state.plazoType}` : location.state.items.Plazo)
            setDescuento(location.state.IsCalculator == "true" ? formatterDolar.format(location.state.items.PagoMensual) : location.state.items.Descuento)
            setCat(location.state.IsCalculator == "true" ? `${location.state.items.CAT} %` : location.state.items.CAT)
            setTasa(location.state.IsCalculator == "true" ? `${location.state.items.TasaAnual} %` : location.state.items.Tasa)
        }
    }, [file]);

    useEffect(() => {
        setLoadView(fileUpdateMetadata.loading)
        if (fileUpdateMetadata.items != undefined && activeUpdateMetadata) {
            setActiveUpdateMetadata(false)
            console.log("Response fileUpdateMetadata: ", fileUpdateMetadata)
            let nextStage = fileUpdateMetadata.items.Stage
            let stageName = nextStage.Name
            let stageId = nextStage.Id
            let folioId = fileId
            let stage = fileUpdateMetadata.items

            let nextComponent = coreFunctions.GetLegoNext(stageName)
            coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })

        } else if (fileUpdateMetadata.error != undefined && activeUpdateMetadata) {
            setActiveUpdateMetadata(false)
            alert(fileUpdateMetadata.error)
        }
    }, [fileUpdateMetadata]);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    let handleBackCalculator = (e) => {
        let nextStage = file.items.Stage
        let stageName = nextStage.Name
        let stageId = nextStage.Id
        let folioId = fileId
        let stage = file.items.Stage

        let nextComponent = (location.state.nameReturn != undefined && location.state.nameReturn != "" ?
            location.state.nameReturn :
            "CalculatorComponent")

        let selectEdit = { plazo: plazo, monto: monto }

        console.log("nextComponent: ", nextComponent)
        coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId, selectEdit } })
    }

    let handleConfirmOferta = (e) => {
        let requestConfirm = {
            "ObjectId": fileId,
            "ContinueWorkFlow": true,
            "Metadata": [
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Monto(Amount)",
                    "Value": monto
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Periodo(PeriodFees)",
                    "Value": 0
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Cuotas(QuantityFees)",
                    "Value": 0
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Fecha vencimiento(ExpirationDate)",
                    "Value": ""
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Fecha primer pago(DateFirstPayment)",
                    "Value": ""
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Tasa(Rate)",
                    "Value": tasa
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Tasa efectiva anual(AnnualEffectiveRate)",
                    "Value": tasa
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Valor cuota(QuotaValue)",
                    "Value": ""
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Plazo(Term)",
                    "Value": plazo
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Total prestamo(TotalLoan)",
                    "Value": descuento
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Intereses(Interests)",
                    "Value": ""
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Tasa efectiva(EffectiveRate)",
                    "Value": plazo
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Capital(Capital)",
                    "Value": ""
                },
                {
                    "GroupName": agrupadorDocumental,
                    "Name": "Tasa nominal anual(AnnualNominalRate)",
                    "Value": ""
                }
            ]
        }
        console.log("Request:-------------------Envio -----: ", requestConfirm)
        dispatch(fileActions.UpdateMetadata(requestConfirm))
        setActiveUpdateMetadata(true)
    }

    const GetNameTitle = (stage) => {
        let setNewOfferData = stage?.Properties?.find(item => item.Name == "SetNewOfferData")
        let valueAgroupRef = (setNewOfferData?.Value == "1" || setNewOfferData?.Value == 1 ? "Oferta de crédito" : "Datos del crédito")
        console.log("setNewOfferData?.Value----------Valor---:", setNewOfferData?.Value, valueAgroupRef)
        setTitle(valueAgroupRef)
    }

    return (<GenericContainer>
        <GenericContainerCenter dynamicSize={240} >
            <Typography variant="h6"
                gutterBottom >{title}
                <HelpRounded
                    className={localStyles.helpIcon}
                    onClick={handleClickOpen}
                />
            </Typography>
            <Typography variant="subtitle2"
                gutterBottom
                className={localStyles.TitleOffer}>Estatus del crédito</Typography>
            <Typography variant="subtitle1"
                gutterBottom
                className={localStyles.subTitleOffer}>Preaprobado</Typography>

            <Grid container spacing={2} justifyContent="center" sx={{ mt: 1, mb: 1 }} >
                <Grid item xs={12} sm={6} sx={{ paddingTop: '2px !important', zIndex: 100 }}>
                    <Typography variant="subtitle2">Folio:</Typography>
                    <Typography variant="subtitle1">{folio}</Typography>
                    <Typography variant="subtitle2">Plazo:</Typography>
                    <Typography variant="subtitle1">{plazo}</Typography>
                    <Typography variant="subtitle2">CAT:</Typography>
                    <Typography variant="subtitle1">{cat}</Typography>
                </Grid>
                <Grid item xs={12} sm={6} sx={{ paddingTop: '2px !important', zIndex: 100 }}>
                    <Typography variant="subtitle2">Monto:</Typography>
                    <Typography variant="subtitle1">{monto}</Typography>
                    <Typography variant="subtitle2">{titleDescuento}</Typography>
                    <Typography variant="subtitle1">{descuento}</Typography>
                    <Typography variant="subtitle2">Tasa efectiva anual:</Typography>
                    <Typography variant="subtitle1">{tasa}</Typography>
                </Grid>
            </Grid>
        </GenericContainerCenter>
        <Buttons ConfirmButtonText='Confirmar'
            onClickConfirm={handleConfirmOferta}
            CancelButtonText={titleButton}
            onClickCancel={handleBackCalculator}
        />

        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
        <GenericDialog open={open}
            onClose={handleClose}
            title="¿Cómo se calculan las comisiones?"
            content={<Box sx={{
                display: 'flex',
                position: 'relative',
                height: '80vh',
                flexDirection: "column",
            }}>
                <Typography variant="h6" gutterBottom  >Tasa anual.</Typography>
                <Typography variant="subtitle1" gutterBottom >{Parser("Es la tasa que se cobra por los préstamos o las ganancias obtenidas a través de una inversión, y se expresa como un porcentaje que representa el costo anual real de los fondos durante el plazo de un préstamo. <br> Esto incluye cualquier cargo o costo adicional asociado con la transacción pero no toma en cuenta la capitalización.")}</Typography>
                <Typography variant="subtitle1" gutterBottom >¿Cómo se calcula la Tasa Anual de un préstamo?</Typography>
                <Typography variant="subtitle1" gutterBottom >{Parser("Para calcular la tasa efectiva anual de un préstamo es necesario conocer el valor neto del préstamo solicitado, la tasa de interés establecida por la entidad financiera o prestamista y el plazo en que el mismo debe ser cancelado <br> Una vez determinadas estas tres variables, se utiliza una fórmula para determinar el valor de cada cuota mensual. <br> Sería: EAR = 1 + inn –1EAR = Tasa de interés efectiva anuali = Tasa de interés nominaln = cantidad de pagos consecutivos cancelados en un añoPasos para calcular la tasa efectiva anual de un préstamo.")}</Typography>
                <Typography variant="subtitle1" gutterBottom >1.En primer lugar se divide la tasa de interés nominal entre 100 para convertirlo en número natural.</Typography>
                <Typography variant="subtitle1" gutterBottom >2.Entonces se divide el resultado entre la cantidad de pagos a realizar en el año, es decir, si es pago mensual seríandividido entre 12, si es pago semestral sería dividido entre 2, etc.</Typography>
                <Typography variant="subtitle1" gutterBottom >3.Se le suma una unidad al resultado (+1)</Typography>
                <Typography variant="subtitle1" gutterBottom >4.El resultado se eleva a la potencia de n (pagos a realizar anualmente).</Typography>
                <Typography variant="subtitle1" gutterBottom >{Parser("5. Por último se resta una unidad (-1) y este será el valor de latasa efectiva de interés anual de un préstamo.<br>Ejemplo:<br> 1.Tenemos una tasa de interés nominal del 15% (15/100 = 0,15), cuyo préstamo debe ser pagado en cuotas trimestrales.")}</Typography>
                <Typography variant="subtitle1" gutterBottom >2.EAR = 0,15/4 (número de trimestres en el año) = 0,0375 + 1 = 1,03753. EAR = 1,0375^4 = 1,1586 –1 = 0,1586</Typography>
            </Box>}
        />
    </GenericContainer>)
}